import React from 'react';
import { Link } from 'react-router-dom';
import { FiGithub, FiTwitter, FiInstagram, FiMail, FiHeart } from 'react-icons/fi';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const tools = [
    { path: '/watermark-removal', label: 'Watermark Removal' },
    { path: '/background-removal', label: 'Background Removal' },
    { path: '/compress', label: 'Image Compression' },
    { path: '/convert', label: 'Format Conversion' },
    { path: '/image-to-pdf', label: 'Image to PDF' },
    { path: '/ai-generate', label: 'AI Generation' },
  ];

  return (
    <footer className="footer">
      <div className="footer-wave">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path 
            d="M0 60L48 55C96 50 192 40 288 45C384 50 480 70 576 75C672 80 768 70 864 60C960 50 1056 40 1152 45C1248 50 1344 70 1392 80L1440 90V120H1392C1344 120 1248 120 1152 120C1056 120 960 120 864 120C768 120 672 120 576 120C480 120 384 120 288 120C192 120 96 120 48 120H0V60Z" 
            fill="url(#footer-gradient)"
          />
          <defs>
            <linearGradient id="footer-gradient" x1="0" y1="0" x2="1440" y2="0">
              <stop offset="0%" stopColor="#667eea" />
              <stop offset="100%" stopColor="#764ba2" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      
      <div className="footer-content">
        <div className="footer-container">
          <div className="footer-grid">
            <div className="footer-brand">
              <Link to="/" className="footer-logo">
                <span className="footer-logo-icon">🥥</span>
                <span className="footer-logo-text">
                  Image<span className="footer-logo-highlight">CoCo</span>
                </span>
              </Link>
              <p className="footer-description">
                Professional AI-powered image processing tools. Fast, free, and easy to use. 
                Transform your images with cutting-edge technology.
              </p>
              <div className="footer-socials">
                <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="social-link">
                  <FiGithub />
                </a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-link">
                  <FiTwitter />
                </a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-link">
                  <FiInstagram />
                </a>
                <a href="mailto:hello@imagecoco.com" className="social-link">
                  <FiMail />
                </a>
              </div>
            </div>

            <div className="footer-links">
              <h4 className="footer-title">Tools</h4>
              <ul>
                {tools.map((tool) => (
                  <li key={tool.path}>
                    <Link to={tool.path}>{tool.label}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-links">
              <h4 className="footer-title">Company</h4>
              <ul>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/privacy">Privacy Policy</Link></li>
                <li><Link to="/terms">Terms of Service</Link></li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </div>

            <div className="footer-links">
              <h4 className="footer-title">Resources</h4>
              <ul>
                <li><Link to="/blog">Blog</Link></li>
                <li><Link to="/faq">FAQ</Link></li>
                <li><Link to="/api">API</Link></li>
                <li><Link to="/support">Support</Link></li>
              </ul>
            </div>
          </div>

          <div className="footer-bottom">
            <p>
              © {currentYear} ImageCoCo. Made with <FiHeart className="heart-icon" /> for creators worldwide.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
